import { createCartPublicApi } from './cart/cartPublicApi';
import { createCheckoutPublicApi } from './checkout/checkoutPublicApi';
import { createNavigatePublicApi } from './navigate/navigatePublicApi';
import { createInternalPublicApi } from './internal/internalPublicApi';
import { createCurrencyPublicApi } from './currency/currencyPublicApi';
import { createInternalOnlineStoresOnlyPublicApi } from './internalOnlineStoresOnly/internalOnlineStoresOnlyPublicApi';
import { EcomPlatformViewerScriptContext } from '../viewer-script/types';
import { createPartialOnlineStoresPublicApi } from '@wix/wixstores-client-storefront-sdk/dist/src/viewer-script/online-stores/Exports/createExports';
import { EcomPlatformViewerScriptContext as SdkEcomPlatformViewerScriptContext } from '@wix/wixstores-client-storefront-sdk';

export const createPublicApiExports = ({
  context,
  origin,
}: {
  context: EcomPlatformViewerScriptContext;
  origin: string;
}) => {
  const onlineStoresPublicApi = createPartialOnlineStoresPublicApi({
    context: context as unknown as SdkEcomPlatformViewerScriptContext,
    origin,
    isOnlineStoresViewerScript: false,
  });
  const ecomPlatformPublicApi = createEcomPlatformPublicApi({
    context,
    origin,
  });

  return {
    ...onlineStoresPublicApi,
    ...ecomPlatformPublicApi,
    navigate: {
      ...onlineStoresPublicApi.navigate,
      ...ecomPlatformPublicApi.navigate,
    },
  };
};

export const createEcomPlatformPublicApi = ({
  context,
  origin,
}: {
  context: EcomPlatformViewerScriptContext;
  origin: string;
}) => ({
  cart: createCartPublicApi({ context, origin }),
  navigate: createNavigatePublicApi({ context, origin }),
  checkout: createCheckoutPublicApi({ context, origin }),
  currency: createCurrencyPublicApi({ context }),
  __internal: createInternalPublicApi({ context }),
  __internalOnlineStoresOnly: createInternalOnlineStoresOnlyPublicApi({
    context,
  }),
});
